module.exports = __webpack_public_path__ + "media/images/home/video_spinbike-ccd80e68847842894f3ed7da567d2139.png";